import { useCallback, useState } from 'react'
import { TreeItemI } from '../components/customTree/CustomTree'
import { customTreeUtils } from '../components/customTree/utils/CustomTree.utils'
interface Props {
  defaultValue?: TreeItemI[]
}
const useCustomTree = (
  props?: Props
): [treeItems: TreeItemI[], setTreeItems: (treeItems: TreeItemI[]) => void] => {
  const [treeItems, setTreeItemsState] = useState<TreeItemI[]>(
    customTreeUtils.updateTreeItemsByChildrensCheck(props?.defaultValue ?? [])
  )

  const setTreeItems = useCallback((treeItems: TreeItemI[]) => {
    setTreeItemsState(
      customTreeUtils.updateTreeItemsByChildrensCheck(treeItems)
    )
  }, [])

  return [treeItems, setTreeItems]
}
export default useCustomTree
